import React from "react"

/**
 * Optional env-driven header copy shown above the sidebar footer.
 *
 * @param {{ isCollapsed?: boolean }} props
 */
export default function SidebarEnvHeaderText({ isCollapsed = false }) {
    // @ts-ignore - Vite injects `import.meta.env` at build time
    const headerPrimary = import.meta.env.VITE_HEADER_TEXT_PRIMARY ?? ""
    // @ts-ignore - Vite injects `import.meta.env` at build time
    const headerSecondary = import.meta.env.VITE_HEADER_TEXT_SECONDARY ?? ""
    const showHeaderText = Boolean(headerPrimary || headerSecondary)

    if (!showHeaderText || isCollapsed) {
        return null
    }

    return (
        <div
            className="pt-3 pb-2"
            style={{
                backgroundColor: "rgba(255, 255, 255, 0.12)",
                border: "1px solid rgba(255, 255, 255, 0.16)",
                borderRadius: "0.75rem",
                padding: "0.75rem 0.875rem",
                marginTop: "0.5rem",
            }}
        >
            {headerPrimary ? (
                <div
                    className="text-white fw-semibold nav-text pb-1"
                    style={{ fontSize: "0.875rem", lineHeight: 1.2 }}
                >
                    {headerPrimary}
                </div>
            ) : null}
            {headerSecondary ? (
                <div
                    className="text-white-50 nav-text pt-1"
                    style={{ fontSize: "0.8125rem", lineHeight: 1.25 }}
                >
                    {headerSecondary}
                </div>
            ) : null}
        </div>
    )
}
